import { Injectable } from '@angular/core';
import { NotificationRepository, NotificationsPage } from 'src/core/notifications/domain/notification-repository';
import { NotificationsService } from 'src/core/notifications/domain/notifications.service';

@Injectable({
  providedIn: 'any',
})
export class ListNotifications {
  constructor(
    private readonly notificationRepository: NotificationRepository,
    private readonly notificationsService: NotificationsService
  ) {}

  async execute(page: number, pageSize: number): Promise<NotificationsPage> {
    const notificationsPage = await this.notificationRepository.list(page, pageSize);
    notificationsPage.notifications = this.notificationsService.withLocalReadState(notificationsPage.notifications);
    await this.store(notificationsPage);
    return notificationsPage;
  }

  // The first page is a fresh start, so it replaces whatever was stored; later pages extend it.
  private async store(notificationsPage: NotificationsPage): Promise<void> {
    if (notificationsPage.page === 1) {
      await this.notificationsService.replaceStoredNotifications(notificationsPage.notifications);
      return;
    }

    await this.notificationsService.appendStoredNotifications(notificationsPage.page, notificationsPage.notifications);
  }
}
